var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-tiptapEditor"},[_c('tiptap-vuetify',{attrs:{"extensions":_vm.extensions},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }